import React, { Component } from 'react';
import server from '../server';

class Line extends Component {
  state = {
    date: new Date()
  }
  
  getLicenseWidth = dates => {
    const dateStart = new Date(dates[0]).getTime(),
      dateEnd = new Date(dates[1]).getTime(),
      todayTime = this.state.date.getTime(),
      fullTime = dateStart - dateEnd;

    return Math.round( Math.abs( (todayTime - dateStart) / ( fullTime / 100 ) ) );
  }
  getLicensePast = dates => {
    const oneDay = 24*60*60*1000,
      dateStart = new Date(dates[0]).getTime(),
      todayTime = this.state.date.getTime();

    return Math.round( Math.abs( (todayTime - dateStart) / oneDay ) );
  }
  getLicenseLeft = dates => {
    const oneDay = 24*60*60*1000,
      dateEnd = new Date(dates[1]).getTime(),
      todayTime = this.state.date.getTime();

    return Math.round( Math.abs( (dateEnd - todayTime) / oneDay ) );
  }
  getLicenseDate = date => {
    if( typeof(date) === 'string' )
      date = new Date(date);

    var day = date.getDate(),
      month = date.getMonth()+1;

    day = day < 10 ? '0'+day : day;
    month = month < 10 ? '0'+month : month;

    return day+'.'+month+'.'+date.getFullYear();
  }
  
  render () {
    if( this.props.date.indexOf('-') === -1 )
      return '';
    
    const dates = this.props.date.replace(/\s/g, '').split('-');
    
    return (
      <div className={'license'+( dates.length ? '' : ' hide' )}>
        <p className="license__line__start">начало <br/>{ this.getLicenseDate(dates[0]) }</p>

        <div className="license__line">
          <div className="license__line__today" style={{ width: this.getLicenseWidth(dates)+'%' }}>
            <span className="license__line__today__date">сегодня { this.getLicenseDate( this.state.date ) }</span>
            <span className="license__line__today__past">прошло<br/>{ this.getLicensePast( dates ) } дня</span>
            <span className="license__line__today__left">осталось<br/>{ this.getLicenseLeft( dates ) } дня</span>
          </div>
        </div>

        <div className="license__line__end">конец <br/>{ this.getLicenseDate(dates[1]) }</div>
      </div>
    );
  }
}

class Cabinet extends Component {

  state = {
    loading: true,
    date: new Date(),
    items: [],
    isDateLoaded: false,
  }

  componentDidMount() {
    if( this.state.isDateLoaded ) return 0;

    if( !this.props.user )
      window.location.href = '/';

    fetch(server.uri+'liacense?token='+this.props.user.token, server.params)
      .then(response => response.json())
      .then(data => {
        this.setState({
          loading: false,
          items: data.items,
          isDateLoaded: true
        })
      });
  }

  render() {
    if( this.state.loading )
      return <div className="loading"></div>;
    
    return (
      <article className="page-infobase">
        <header className="main__header">
          <h1 className="main__title">Личный кабинет</h1>
        </header>

        <section className="main__content">
          <br/>
          <ul className="license__list">
            { this.state.items && this.state.items.map((license,i) => {
              return <li key={i}>
                  <h2 id={'license'+(i+1)} className="main__title">{ license.title }</h2>
                  <Line date={ license.date }/>
                  <div className="page__content" dangerouslySetInnerHTML={{ __html: license.content }}></div>
                </li>;
            })}
          </ul>
        </section>
      </article>
    );
  }
}
export default Cabinet;
